<template>
    <CommKhSection
        :images="[{
            alt: 'Arbeitgeberprofil Plus',
            url: '/images/landingpages/arbeitgeberprofil-plus.webp',
            width: 600,
            height: 430,
        }]"
        link="/produkte/arbeitgeberprofil"
        reverse-order
    >
        <template #headline>
            Arbeitgeberprofil Plus
        </template>
        <template #description>
            Präsentieren Sie Ihr Unternehmen auf karriere.at mit dem Arbeitgeberprofil Plus als attraktiven Arbeitgeber!
            Geben Sie authentische Einblicke in den Arbeitsalltag, lassen Sie Ihr Team zu Wort kommen und zeigen Sie,
            wofür Ihr Unternehmen steht. Integrieren Sie zudem Ihren Social Media Feed, um Ihr Profil lebendig und
            aktuell zu halten. So steigern Sie Ihre Sichtbarkeit und ziehen die passenden Talente an!
        </template>
    </CommKhSection>
</template>
